{
  "version": 1,
  "asset_id": "f025ba6e-ee98-4cd1-96c9-9365c97a73be",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/f025ba6e-ee98-4cd1-96c9-9365c97a73be/stappenplan-aanleg-480.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/f025ba6e-ee98-4cd1-96c9-9365c97a73be/stappenplan-aanleg-480.avif",
  "original_filename": "stappenplan-aanleg-480.avif",
  "size": 11408,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:05:31Z"
}
